import {DatePicker} from '@mantine/dates';
import classes from './date-picker.module.css';

export const DatePickerTheme = DatePicker.extend({
  classNames: {
    day: classes.day,
  },
});